<template>
  <div class="dispense-form">
    <div class="top-section">
      <div class="input-group col-span-12 sm:col-span-6">
        <select
          v-model="form.bay_number"
          name="bay_number"
          id="bay_number"
        >
          <option :value="null">Select Bay</option>
          <option
            v-for="option in bayOptions"
            :value="option.value"
          >
            {{ option.label }}
          </option>
        </select>
        <p
          v-if="getErrors('bay_number', form)"
          class="input-error"
        >
          {{ getErrors('bay_number', form) }}
        </p>
      </div>
    </div>
    <div class="mt-6 border-t border-gray-400">
      <div
        v-for="product in form.products"
        class="input-group sm:grid sm:grid-cols-4 sm:gap-4 sm:items-start py-4 border-b border-gray-400"
      >
        <label
          v-if="getProduct(product.id)"
          :for="'product-quantity-' + product.id"
          class="sm:col-span-2 block self-center"
        >
          {{ getProduct(product.id).name }}
          <br />
          <small>QTY AVAILABLE: {{ getProduct(product.id).quantity_available }}</small>
        </label>
        <div class="mt-1 sm:mt-0 sm:col-span-2">
          <input
            v-model="product.quantity"
            type="number"
            :id="'product-quantity-' + product.id"
            class="max-w-lg block w-full self-center"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useForm } from '@inertiajs/vue3'
import checksErrors from '@/Mixins/checksErrors'

export default {
  mixins: [checksErrors],

  props: {
    products: {
      type: Array,
      default() {
        return []
      }
    }
  },

  data() {
    return {
      bayOptions: [
        { value: 1, label: 'Bay 1' },
        { value: 2, label: 'Bay 2' },
        { value: 3, label: 'Bay 3' },
        { value: 4, label: 'Bay 4' },
        { value: 5, label: 'Bay 5' },
        { value: 6, label: 'Bay 6' },
        { value: 7, label: 'Bay 7' },
        { value: 8, label: 'Bay 8' },
        { value: 9, label: 'Bay 9' },
        { value: 10, label: 'Bay 10' }
      ],
      form: {
        bay_number: null,
        products: []
      }
    }
  },

  created() {
    const products = this.products.map((product) => {
      return {
        id: product.id,
        quantity: 0
      }
    })

    this.form = useForm({
      ...this.form,
      products: products
    })
  },

  methods: {
    getProduct(id) {
      return _.find(this.products, (product) => {
        return product.id === id
      })
    },
    save() {
      this.$emit('dispensing')

      this.form.post(route('products.dispense'), {
        onSuccess: () => {
          this.$emit('dispensed')
        }
      })
    }
  }
}
</script>
